import { ThemeProvider, CssBaseline, AppBar, Box, Container, Toolbar, Typography } from '@mui/material';
import { Calculator } from './components/Calculator';
import { UserMenu } from './components/UserMenu';
import { AuthProvider } from './contexts/AuthContext';
import { theme } from './theme';

function App() {
  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <AppBar position="static" color="default" elevation={1} sx={{ width: '100%' }}>
            <Container maxWidth="xl">
              <Toolbar>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                  Gene Therapy Market Calculator
                </Typography>
                <UserMenu />
              </Toolbar>
            </Container>
          </AppBar>
          <Box sx={{ width: '100%', flex: 1, mt: 4, mb: 4 }}>
            <Container maxWidth="xl">
              <Calculator />
            </Container>
          </Box>
        </Box>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
